export enum PresenterState {
  LoadingAppointmentTypes,
  LoadingQuestions,
  NoAppointmentTypes,
  Ready,
  Error,
}
